import React, { useEffect, useState } from 'react';
import './index.scss';
import ProductList from 'common/components/ProductList';
import { getPathApi, getMenusApi } from 'lib/Apis';
import Floating from '../../common/components/Floating';
interface Floor {
  [key: string]: any;
  type: string;
}

const Main: React.FC = () => {
  let [floorsList, setFloorsList] = useState<Floor[]>([]);
  const [ext, setExt] = useState({});
  useEffect(() => {
    document.title = '成长优享，安联财险成长优享，成长优享儿童高端医疗保险，旅行险，申根，京东安联申根旅行险，高端医疗';
    getFloors();
    window.scrollTo(0, 0);
  }, []);

  const getFloors = async () => {
    try {
      const path: any = await getPathApi('bxsc');
      const floorsObj: any = await getMenusApi(path.dataPath);
      setExt(floorsObj.ext);
      setFloorsList(floorsObj.floors);
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <div className='bxsc_wrap'>
      {floorsList.map((floor, index) => {
        return (
          <section key={index}>
            {floor.type === 'level2Nav' && (
              <ProductList productData={floor.level2Nav} ext={ext} />
            )}
          </section>
        );
      })}
      <Floating />
    </div>
  );
};
export default Main;
